import React from "react";
import { useQuery } from "@tanstack/react-query";
import { ProductCreatedPage } from "./ProductCreatedPage";
import { useGreeterVenueApi } from "@greeter/matter";

// TODO: What an insane name
export type ProductCreatedPageApiHandlerProps = {
  id: string;
};

export const ProductCreatedPageApiHandler: React.FC<
  ProductCreatedPageApiHandlerProps
> = ({ id }) => {
  const { api: venueApi } = useGreeterVenueApi();

  const productQuery = useQuery({
    queryKey: ["product", id],
    queryFn: async () => await venueApi.fetchProduct(id),
  });

  return <ProductCreatedPage product={productQuery.data ?? "loading"} />;
};
